import { IAgreementsStateSlice } from './AgreementSliceModels';

export const initialState: IAgreementsStateSlice = {
	agreements: [],
	isValid: false,
	allAgreementsChecked: false,
	allAgreementsExpanded: false,
};
